import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	Grid,
	InputLabel,
	Radio,
	RadioGroup,
	TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomFloat2 from "../components/containers/BottomFloat2";
import FetchLogin from "../components/Fetch/FetchLogin";
import RetailerAccountTemplate from "../components/RetailerAccountTemplate";
import Withhold from "../components/Withhold";
import {
	resetWithdrawals,
	setDepositWithdrawals,
} from "../redux/items/DepositWithdrawal";
import { setLoadingPage } from "../redux/items/PageLoading";
import { parseInt2 } from "../utils/functions";

const Withdrawals = () => {
	const [v, setV] = useState({
		forceUpdate: 0,
		amount: "",
		modal: false,
		success: true,
		error: "",
		tnc: false,
		caution: false,
		alertMessage: "",
		withdraw_popup_message_modal: false,
	});

	const dispatch = useDispatch();
	const set = useSelector((state) => state.drawSet.set);
	const withdrawal = useSelector((state) => state.DepositWithdrawal.withdrawal);
	const withdraw_popup_message = useSelector((state) => {
		if (state.drawSet.set.withdraw_popup_message) {
			if (
				state.drawSet.set.withdraw_popup_message.trim().toLowerCase() ===
				"empty"
			) {
				return false;
			}
			return state.drawSet.set.withdraw_popup_message;
		}
		return false;
	});

	const token = useSelector((state) => state.login.token);
	const login = useSelector((state) => state.login);
	const contact_no = useSelector((state) => state.login.user.contact_no);

	React.useEffect(() => {
		dispatch(setDepositWithdrawals("withdrawal.paynow_no", contact_no));
		// eslint-disable-next-line
	}, []);

	const reqWithdraw = FetchLogin("withdraw", {
		data: {
			token: token,
			method: withdrawal.type,
			amount: v.amount === "" ? 0 : v.amount,
			paynow_no: withdrawal.paynow_no,
			comments: withdrawal.comments,
			bank_name: withdrawal.fund_transfers.bank_name,
			acct_no: withdrawal.fund_transfers.acct_no,
		},
		callbackInit: () => {
			setV2({ success: true, error: "", caution: false });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			setV2({ success: cb.response.success, error: cb.response.message });
			dispatch(setLoadingPage(false));
		},
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	return (
		<RetailerAccountTemplate title="Withdrawal Request">
			<Withhold />
			<p style={{ border: "3px solid red", padding: 10 }}>
				{/* After submitting a withdrawal request, the withdrawal amount cannot be
        used for betting. For withdrawal amounts up to SGD 200,000. You will be
        receiving your payout within 24 hours after you initiated a withdrawal
        request. */}
				All withdrawals take up to 24 hours for you to receive it into your
				bank. All withdrawals requested can not be used for betting.
			</p>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",

					margin: "0 auto",
				}}
			>
				<div style={{ fontSize: 20, paddingRight: 24 }}>Withdrawal Method</div>
				<RadioGroup
					aria-labelledby="deposit_method"
					defaultValue="paynow"
					name="deposit_method"
					value={withdrawal.type}
					onChange={(e) => {
						dispatch(setDepositWithdrawals("withdrawal.type", e.target.value));
						setV2({ forceUpdate: v.forceUpdate + 1 });
					}}
				>
					<FormControlLabel
						value="paynow"
						control={<Radio />}
						label={
							<>
								PayNow <small style={{ color: "blue" }}>(Below S$1,000)</small>
							</>
						}
					/>
					<FormControlLabel
						value="fund-transfers"
						control={<Radio />}
						label={
							<>
								Fund Transfer{" "}
								<small style={{ color: "blue" }}>(Above S$1,000)</small>
							</>
						}
					/>
				</RadioGroup>
			</div>
			<Grid container xs={12}>
				{withdrawal.type === "paynow" && (
					<>
						{/* eslint-disable-next-line  */}
						{set.enable_withdraw_paynow == "0" && (
							<div
								style={{
									color: "red",
									textAlign: "center",
									width: "100%",
									height: 50,
								}}
							>
								PayNow Withdrawal Temporarily unavailable, Please use fund
								transfer
							</div>
						)}
					</>
				)}
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display:
						withdrawal.type === "paynow"
							? // eslint-disable-next-line
							  set.enable_withdraw_paynow == "1"
								? "flex"
								: "none"
							: "flex",
				}}
			>
				<Grid
					item
					container
					xs={6}
					style={{
						justifyContent: "flex-start",
						alignItems: "center",
					}}
				>
					<InputLabel htmlFor="withdrawal-amount" style={{ fontSize: 18 }}>
						Withdrawal Amount
					</InputLabel>
				</Grid>
				<Grid item xs={6}>
					<div style={{ display: "flex", flexDirection: "row" }}>
						<span
							style={{
								border: "1px solid #ccc",
								padding: "0 20px",
								display: "flex",
								alignItems: "center",
								color: "#333",
							}}
						>
							SGD
						</span>
						<TextField
							id="withdrawal-amount"
							aria-describedby="withdrawal-amount"
							className="left-label"
							value={parseInt2(v.amount, "")}
							onChange={(e) => setV2({ amount: parseInt2(e.target.value, "") })}
							variant="outlined"
						/>
					</div>
					<i style={{ color: "red", fontWeight: "thin" }}>
						Minimum of SGD 10
						<br /> Maximum of SGD 20,000
					</i>
				</Grid>
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display: withdrawal.type === "paynow" ? "none" : "flex",
				}}
			>
				{set.enable_withdraw_fund_transfer ? (
					<>
						<Grid
							item
							container
							xs={6}
							style={{ justifyContent: "flex-start", alignItems: "center" }}
						>
							<InputLabel htmlFor="bank-name" style={{ fontSize: 18 }}>
								Bank Name
							</InputLabel>
						</Grid>
						<Grid item xs={6}>
							<TextField
								id="bank-name"
								aria-describedby="bank-name"
								value={withdrawal.fund_transfers.bank_name}
								onChange={(e) => {
									dispatch(
										setDepositWithdrawals(
											"withdrawal.fund_transfers.bank_name",
											e.target.value
										)
									);
									setV2({ forceUpdate: v.forceUpdate + 1 });
								}}
								variant="outlined"
							/>
						</Grid>
					</>
				) : null}
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display: withdrawal.type === "paynow" ? "none" : "flex",
				}}
			>
				{set.enable_withdraw_fund_transfer ? (
					<>
						<Grid
							item
							container
							xs={6}
							style={{ justifyContent: "flex-start", alignItems: "center" }}
						>
							<InputLabel htmlFor="account-number" style={{ fontSize: 18 }}>
								Account Number
							</InputLabel>
						</Grid>
						<Grid item xs={6}>
							<TextField
								id="account-number"
								aria-describedby="account-number"
								value={withdrawal.fund_transfers.acct_no}
								onChange={(e) => {
									dispatch(
										setDepositWithdrawals(
											"withdrawal.fund_transfers.acct_no",
											e.target.value
										)
									);
									setV2({ forceUpdate: v.forceUpdate + 1 });
								}}
								variant="outlined"
							/>
						</Grid>
					</>
				) : (
					<p
						style={{
							color: "red",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							width: "100%",
							//   backgroundColor: "blue",
						}}
					>
						<span>Fund Transfer temporarily unavailable</span>
					</p>
				)}
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display:
						withdrawal.type === "fund-transfers"
							? "none"
							: // eslint-disable-next-line
							set.enable_withdraw_paynow == "1"
							? "flex"
							: "none",
				}}
			>
				{set.enable_withdraw_fund_transfer ? (
					<>
						<Grid
							item
							container
							xs={6}
							style={{ justifyContent: "flex-start", alignItems: "center" }}
						>
							<InputLabel htmlFor="paynow-number" style={{ fontSize: 18 }}>
								PayNow Number
								<p style={{ marginTop: 4, fontSize: 14 }}>
									Only available In Singapore bank accounts
								</p>
							</InputLabel>
						</Grid>
						<Grid item xs={6}>
							{/* <TextField
			id="paynow-number"
			aria-describedby="paynow-number"
			value={withdrawal.paynow_number}
			onChange={(e) => {
				dispatch(
					setDepositWithdrawals(
						"withdrawal.paynow_number",
						e.target.value
					)
				);
				forceUpdate();
			}}
			variant="outlined"
		/> */}
							<span
								style={{
									padding: "10px 0",
									display: "inline-block",
									// background: "blue",
								}}
							>
								{withdrawal.paynow_no}
							</span>
						</Grid>
					</>
				) : (
					<p
						style={{
							color: "red",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							width: "100%",
							//   backgroundColor: "blue",
						}}
					>
						<span>PayNow temporarily unavailable</span>
					</p>
				)}
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display:
						withdrawal.type === "paynow"
							? // eslint-disable-next-line
							  set.enable_withdraw_paynow == "1"
								? "flex"
								: "none"
							: "flex",
				}}
			>
				<Grid
					item
					container
					xs={6}
					style={{ justifyContent: "flex-start", alignItems: "center" }}
				>
					<InputLabel htmlFor="comments" style={{ fontSize: 18 }}>
						Comments
					</InputLabel>
				</Grid>
				<Grid item xs={6}>
					<TextField
						id="comments"
						aria-describedby="comments"
						multiline={true}
						minRows={3}
						maxRows={10}
						placeholder={
							withdrawal.type === "paynow" ? "VPA DASH/GRAB if Applicable" : ""
						}
						value={withdrawal.comments}
						onChange={(e) => {
							dispatch(
								setDepositWithdrawals("withdrawal.comments", e.target.value)
							);
							setV2({ forceUpdate: v.forceUpdate + 1 });
						}}
						variant="outlined"
					/>
				</Grid>
			</Grid>
			<Grid
				container
				style={{
					marginTop: 20,
					display:
						withdrawal.type === "paynow"
							? // eslint-disable-next-line
							  set.enable_withdraw_paynow == "1"
								? "flex"
								: "none"
							: "flex",
				}}
			>
				<Grid
					item
					container
					xs={6}
					style={{ justifyContent: "flex-start", alignItems: "center" }}
				></Grid>
				<Grid item xs={6} style={{ textAlign: "center" }}>
					<Button size={"small"} onClick={() => setV2({ modal: true })}>
						Reset All Text Fields
					</Button>
				</Grid>
			</Grid>
			<Grid container style={{ marginTop: 20 }}>
				<Grid
					item
					container
					xs={12}
					style={{
						justifyContent: "flex-start",
						alignItems: "center",
						display:
							withdrawal.type === "paynow"
								? // eslint-disable-next-line
								  set.enable_withdraw_paynow == "1"
									? "flex"
									: "none"
								: "flex",
					}}
				>
					<label
						style={{
							color: "rgba(0, 0, 0, 0.54)",
							cursor: "pointer",
							fontFamily: "Roboto, Helvetica, Arial, sans-serif",
							fontSize: 18,
						}}
					>
						<Grid container>
							<Grid
								item
								xs={2}
								container
								style={{ justifyContent: "center", alignItems: "center" }}
							>
								<input
									type="checkbox"
									style={{ fontSize: 20 }}
									onClick={() => {
										setV2({ tnc: !v.tnc });
									}}
									checked={v.tnc}
								/>
							</Grid>
							<Grid item xs={10} className="noselect">
								We are NOT responsible for ANY incorrect information provided by
								you. Please ensure ALL information provided by you are correct
								before submitting.
							</Grid>
						</Grid>
					</label>
				</Grid>
			</Grid>
			<p
				dangerouslySetInnerHTML={{ __html: v.error }}
				style={{
					color: v.success ? "green" : "red",
					textAlign: "center",
					fontSize: 22,
				}}
			/>
			{/* <pre>{JSON.stringify(login, null, 2)}</pre> */}
			<BottomFloat2
				moneyTitle="Withdrawal Amount"
				title="Submit"
				total={v.amount === "" ? 0 : v.amount}
				onClick={() => {
					if (!v.tnc)
						setV2({ alertMessage: "Please accept the terms and conditions" });
					else {
						let pop = false;
						if (v.amount === "") {
							setV2({ alertMessage: "Please enter the withdrawal amount" });
							pop = true;
						}
						if (v.amount !== "") {
							if (v.amount && !Number.isInteger(parseInt2(v.amount))) {
								setV2({ alertMessage: "Please enter a valid integer amount" });
								pop = true;
							} else if (v.amount < 10) {
								setV2({ alertMessage: "Minimum withdrawal amount is SGD 10" });
								pop = true;
							}
						}

						if (!pop) {
							if (login.user?.allowableWithdraw) {
								if (login.user.allowableWithdraw - v.amount < 0) {
									pop = true;
									setV2({ caution: true });
								}
							}
						}
						if (!pop) {
							if (!withdraw_popup_message) {
								reqWithdraw.handleTrigger();
							} else {
								setV2({ withdraw_popup_message_modal: true });
							}
						}
					}
				}}
				style={{
					display:
						withdrawal.type === "paynow"
							? // eslint-disable-next-line
							  set.enable_withdraw_paynow == "1"
								? "flex"
								: "none"
							: "flex",
				}}
			/>
			<Dialog open={v.modal} onClose={() => setV2({ modal: false })}>
				<DialogContent>
					<DialogContentText>
						Are you Sure? You want to empty the text fields
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							dispatch(resetWithdrawals());
							dispatch(
								setDepositWithdrawals("withdrawal.paynow_no", contact_no)
							);
							setV2({ modal: false, amount: "" });
						}}
					>
						Yes
					</Button>
					<Button
						onClick={() => {
							setV2({ modal: false });
						}}
					>
						No
					</Button>
				</DialogActions>
			</Dialog>
			<ContinueDialog
				open={v.caution}
				onClose={() => setV2({ caution: false })}
				onContinue={() => {
					reqWithdraw.handleTrigger();
				}}
			/>
			<AlertDialog
				open={v.alertMessage !== ""}
				onClose={() => setV2({ alertMessage: "" })}
				message={v.alertMessage}
			/>
			<Dialog
				open={v.withdraw_popup_message_modal}
				onClose={() => setV2({ withdraw_popup_message_modal: false })}
				maxWidth="xs"
			>
				<DialogTitle>Confirm</DialogTitle>
				<DialogContent>
					<DialogContentText>{withdraw_popup_message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setV2({ withdraw_popup_message_modal: false })}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={() => reqWithdraw.handleTrigger()}
					>
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</RetailerAccountTemplate>
	);
};

export default Withdrawals;

const ContinueDialog = ({
	open,
	onClose = () => {},
	onContinue = () => {},
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				style: {
					maxWidth: "600px",
					margin: "0 auto",
					border: "2px solid #ff0000",
				},
			}}
		>
			<DialogContent style={{ backgroundColor: "#fff8f8" }}>
				<DialogContentText style={{ color: "#d32f2f" }}>
					<span style={{ fontSize: 40 }}>⚠️</span> We notice you top up and
					withdraw without betting. This action could lead to your account being
					suspended.
				</DialogContentText>
			</DialogContent>
			<DialogActions style={{ backgroundColor: "#fff8f8" }}>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					onClick={onContinue}
					style={{
						backgroundColor: "#d32f2f",
						color: "white",
					}}
				>
					Continue
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const AlertDialog = ({
	open,
	onClose = () => {},
	message,
	title = "Alert",
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				style: {
					maxWidth: "600px",
					margin: "0 auto",
				},
			}}
		>
			<DialogContent>
				<DialogContentText>{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
